import { useRest } from "../useRest";
import { buildKey } from "../utils/buildKey";
import { buildPrefetch } from "../utils/buildPrefetch";
import { routeTo } from "../utils/routeTo";
import { defaultOptions } from "./defaultOptions";

// Endpoints
const routes = {
  archetypes: () => routeTo("codex", "archetypes"),
  archetype: (id) => routeTo("codex", "archetypes", id),
};

// Cache Keys
const keys = {
  archetypes: () => buildKey("codex", "archetypes"),
  archetype: (id) => buildKey("codex", "archetypes", id),
};

// Prefetch resources
const prefetch = (queryClient) => ({
  list: (options) =>
    buildPrefetch({
      queryClient,
      url: routes.archetypes(),
      key: keys.archetypes(),
      options,
    }),
});

// Resource CRUD actions
const actions = {
  list: (options) =>
    useRest.fetch({
      url: routes.archetypes(),
      key: keys.archetypes(),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
  fetch: (id, options) =>
    useRest.fetch({
      url: routes.archetype(id),
      key: keys.archetype(id),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
};

/**
 * Assemble export
 */
export const useCodexArchetype = {
  routes,
  keys,
  prefetch,
  ...actions,
};
